<template>
  <div class="bg-white shadow-md rounded-lg border border-gray-200 overflow-hidden">
    <div class="p-5 border-b border-gray-200 bg-[#F8FAFC]">
      <h3 class="text-lg font-semibold text-gray-800">Estimate summary</h3>
      <p class="text-sm text-gray-500">How this configuration is calculated</p>
    </div>

    <div class="p-5 space-y-4">
      <div v-for="line in lines" :key="line.key" class="border border-slate-200 rounded-lg overflow-hidden">
        <div class="flex items-start justify-between gap-4 p-4 bg-slate-50">
          <div class="min-w-0">
            <h4 class="font-medium text-slate-800">{{ line.name }}</h4>
            <p v-if="line.quantity > 1" class="text-xs text-slate-500">
              {{ line.quantity }} × {{ formatMoney(line.unitMonthlyCost) }} per month
            </p>
          </div>
          <div class="text-right shrink-0">
            <p class="font-semibold text-slate-800">
              <span v-if="line.onRequest" class="text-sm text-indigo-600">On request</span>
              <span v-else v-currency="line.monthlyCost" :key="line.monthlyCost">{{ line.monthlyCost }}</span>
            </p>
            <p class="text-xs text-slate-500">per month</p>
          </div>
        </div>

        <LineItems v-if="line.items && line.items.length" :items="line.items" />

        <p v-else-if="line.onRequest" class="p-4 text-sm text-slate-600">
          This resource is priced individually — it is listed in your estimate without a cost.
        </p>
      </div>

      <div class="flex items-center justify-between pt-2 border-t border-slate-200">
        <div>
          <p class="text-sm text-slate-600">Total monthly</p>
          <p class="text-xs text-slate-500">
            12 months: <span v-currency="totalYearly" :key="totalYearly">{{ totalYearly }}</span>
          </p>
        </div>
        <p class="text-xl font-bold text-slate-800">
          <span v-currency="totalMonthly" :key="totalMonthly">{{ totalMonthly }}</span>
        </p>
      </div>

      <p v-if="hasOnRequest" class="text-xs text-indigo-700 bg-indigo-50 border border-indigo-200 rounded p-3">
        Items marked "on request" are quoted individually and are not part of the total above.
      </p>
    </div>
  </div>
</template>

<script>
import LineItems from "@/components/config/LineItems.vue";
import { round } from "@/utils/pricing";

export default {
  name: "CostPreview",
  components: { LineItems },
  props: {
    line: { type: Object, default: null },
    linesProp: { type: Array, default: null },
  },
  computed: {
    lines() {
      if (this.linesProp) return this.linesProp;
      return this.line ? [this.line] : [];
    },
    totalMonthly() {
      return this.lines.reduce((total, line) => total + (line.monthlyCost || 0), 0);
    },
    totalYearly() {
      return this.lines.reduce((total, line) => total + (line.totalCost || 0), 0);
    },
    hasOnRequest() {
      return this.lines.some((line) => line.onRequest);
    },
  },
  methods: {
    formatMoney(value) {
      return `${round(value)} €`;
    },
  },
};
</script>
